import { useState } from "react";
import { AlertTriangle, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export function DangerZoneSection() {
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState("");

  function handleDelete() {
    // V1: backend doesn't expose self-delete yet — point to admin.
    toast.info("Contact your administrator to delete your account");
    setOpen(false);
    setConfirm("");
  }

  return (
    <section className="rounded-plane bg-white p-6 shadow-plane">
      <h2 className="text-lg font-medium tracking-tight text-rose-700">
        Danger zone
      </h2>
      <p className="mt-1 text-sm text-slate-500">
        Irreversible actions on your account
      </p>

      <div className="mt-5 flex items-start justify-between gap-4 rounded-lg border border-rose-200/60 bg-rose-50/30 px-4 py-3">
        <div>
          <p className="text-sm font-semibold text-slate-900">
            Delete my account
          </p>
          <p className="mt-1 text-xs text-slate-500">
            Permanently remove your account, tasks, and project memberships.
            This cannot be undone.
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setOpen(true)}
          className="shrink-0 border-rose-200 text-rose-700 hover:bg-rose-50"
        >
          <Trash2 className="mr-2 h-3.5 w-3.5" />
          Delete account
        </Button>
      </div>

      <Dialog
        open={open}
        onOpenChange={(o) => {
          setOpen(o);
          if (!o) setConfirm("");
        }}
      >
        <DialogContent className="sm:max-w-[480px]">
          <DialogHeader>
            <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-rose-50 text-rose-600">
              <AlertTriangle className="h-5 w-5" />
            </div>
            <DialogTitle className="text-center">
              Delete your account?
            </DialogTitle>
            <DialogDescription className="text-center text-sm leading-relaxed">
              This action is irreversible. All your data, tasks, and settings
              will be permanently deleted. Your memberships in all projects will
              be removed.
            </DialogDescription>
          </DialogHeader>

          <div>
            <label className="block text-xs font-medium text-slate-600">
              Type <span className="font-mono font-bold">DELETE</span> to
              confirm
            </label>
            <Input
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoFocus
              className="mt-1.5 h-10 rounded-lg font-mono"
              placeholder="DELETE"
            />
          </div>

          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={handleDelete}
              disabled={confirm !== "DELETE"}
            >
              <Trash2 className="mr-2 h-3.5 w-3.5" />
              Delete my account
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </section>
  );
}
